import Vue from 'vue';
import Vuex from 'vuex';
import cookies from 'axios/lib/helpers/cookies';
import ADL from './ADL';
import EventBus from './event-bus';

Vue.use(Vuex);

const adl = new ADL();
const dialogsStoreKey = 'nnru_privat_dialogs_';
const dialogsStoreSeparator = '.';
const updateMessagesLocks = [];
let updateDialogNewMessagesTimer = null;

export default new Vuex.Store({
  state: {
    dialog: null,
    dialogs: [],
    groups: [],
    search: {
      count: 0,
      items: []
    },
    users: [],
    userAuthID: 0
  },
  mutations: {
    setGroups(state, data) {
      state.groups = data;
    },
    setUsers(state, data) {
      state.groups = state.groups.map(group => {
        if (group.id === data.id) {
          if (group.users) {
            group.users.items = group.users.items.concat(data.users.items);
            group.users.nextPage = data.users.nextPage;
          } else {
            group.users = data.users;
          }
          group.users.currentPage = data.currentPage;
        }
        return group;
      });
    },
    setUserAuthID(state, data) {
      state.userAuthID = data;
    },
    addDialog(state, data) {
      state.dialogs.push(data);
    },
    removeDialog(state, key) {
      state.dialogs.splice(key, 1);
    },
    setActiveDialog(state, data) {
      state.dialog = data;
    },
    closeDialog(state) {
      state.dialog = null;
    },
    addUsersGroupDialog(state, data) {
      data.users.forEach(item => {
        const { users } = state.dialog;
        if (!users.some(el => el.id === item.id)) {
          state.dialog.users.push(item);
        }
      });
    },
    setUsersGroupDialog(state, users) {
      state.dialog.users = users
    },
    removeUsersGroupDialog(state, data) {
      data.users.forEach(item => {
        const { users } = state.dialog;
        const key = users.findIndex(el => el.id === item.id);
        if (key >= 0) {
          state.dialog.users.splice(key, 1);
        }
      });
    },
    addTextFormDialog(state, data) {
      state.dialog.form = data;
    },
    addSelectedTextDialog(state, data) {
      state.dialog.selectedText = data;
    },
    exequteSearch(state, data) {
      state.search = data;
    },
    storeDialogs(state) {
      const ids = [];
      state.dialogs.forEach(dialog => {
        if (dialog.group === null) {
          ids.push(dialog.id);
        }
      });
      localStorage.setItem(dialogsStoreKey + this.state.userAuthID, ids.join(dialogsStoreSeparator));
    },
    resetDialogNewMessageCount(state) {
      state.dialog.newMessageCount = 0;
    }
  },
  actions: {
    setUserAuthID({ commit }, data) {
      commit('setUserAuthID', data);
    },
    async setGroups({ commit }) {
      const groups = await adl.getGroups();
      commit('setGroups', groups);
    },
    async setUsers({ commit }, data) {
      const users = await adl.getUsers(data.id, data.page);
      commit('setUsers', { id: data.id, users, currentPage: data.page });
    },
    async setUser({ commit }, data) {
      const user = await adl.getUser(data.id);
      commit('setUser', user);
    },
    async createDialog({ commit }, data) {
      const dialog = {
        key: data.key,
        id: data.id,
        title: data.title,
        content: [],
        selectedText: '',
        form: '',
        users: data.users,
        group: data.group,
        newMessageCount: 0
      };
      if (dialog.group === null) {
        dialog.user = await adl.getUser(data.id);
      }
      commit('addDialog', dialog);
      commit('storeDialogs');
      this.dispatch('openDialog', dialog);
    },
    openDialog({ commit }, data) {
      const { dialogs } = this.state;
      const dialog = dialogs.find(i => i.key === data.key);
      commit('setActiveDialog', dialog);
      EventBus.$emit('storeOpenDialog', dialog);
      this.dispatch('updateMessages');
    },
    closeDialog({ commit }) {
      commit('closeDialog');
    },
    removeDialog({ commit }, data) {
      const { dialogs } = this.state;
      const key = dialogs.findIndex(el => el.key === data.key);
      if (key >= 0) {
        commit('removeDialog', key);
        commit('storeDialogs');
      }
    },
    updateGroupDialog({ commit }, data) {
      commit('setUsersGroupDialog', data.users)
    },

    dialogAddForm({ commit }, data) {
      commit('addTextFormDialog', data);
    },

    addSelectedTextDialog({ commit }, data) {
      commit('addSelectedTextDialog', data);
    },

    async exequteSearch({ commit }, data) {
      const users = await adl.getSearch(data);
      if (users !== null) {
        commit('exequteSearch', users);
      }
    },
    async updateMessages({ commit }) {
      const { dialog } = this.state;
      if (dialog === null) {
        return;
      }

      if (updateMessagesLocks.some((elem) => elem === dialog.key)) {
        return;
      }
      updateMessagesLocks.push(dialog.key);

      EventBus.$emit('storeBeforeUpdateMessages', dialog);
      let lastMessageID = 0;
      const messagesForStatus = [];
      dialog.content.forEach(await async (message) => {
        lastMessageID = message.id;
        if (message.isMine) {
          messagesForStatus.push(message.id);
        }
      });

      if (messagesForStatus.length) {
        const statusesResponse = await adl.getMessagesStatus(
            messagesForStatus
        );

        dialog.content.forEach((message) => {
          const newStatusText = statusesResponse[message.id];
          if (newStatusText !== undefined) {
            message.statusText = newStatusText;
          }
        });
      }

      let content = await adl.getMessagesLast(
          dialog.id,
          lastMessageID,
          dialog.group !== null
      );
      if (content === null) {
        alert('Ошибка подгрузки сообщений');
        content = [];
      }
      // если это не первоначальная загрузка увеличиваем счетчик новых сообщений
      if (dialog.content.length) {
        dialog.newMessageCount += content.length
      }
      dialog.content = dialog.content.concat(content);
      EventBus.$emit('storeAfterUpdateMessages', dialog);
      updateMessagesLocks.splice(updateMessagesLocks.indexOf(dialog.key), 1)
    },
    async updateNewMessagesCounters({commit}) {
      const peers = [];
      this.state.dialogs.forEach((item) => {
        if (item.group === null) {
          peers.push(item.id);
        }
      });
      if (!peers.length) {
        return;
      }

      const countResponse = await adl.getMessagesNewCount(
          peers
      );

      this.state.dialogs.forEach((dialog) => {
        const count = countResponse[dialog.id];
        if (count) {
          dialog.newMessageCount = count;
        }
      });
    },
    async restoreDialogs({commit}, data) {
      localStorage.removeItem('nnru_privat_dialogs');
      let storedIDs = localStorage.getItem(dialogsStoreKey + this.state.userAuthID);
      if (storedIDs === null) {
        storedIDs = [];
      } else {
        storedIDs = storedIDs.split(dialogsStoreSeparator);
      }
      if (data.userTo) {
        const indx = storedIDs.indexOf(data.userTo);
        if (indx > -1) {
          storedIDs.splice(indx, 1);
        }
        storedIDs.unshift(data.userTo);
      }

      storedIDs.forEach(await async(id, index) => {
        const dialogData = await this.dispatch('addDialogByUserID', id);
        if (index === 0) {
          this.dispatch('openDialog', dialogData);
        }
        if (index === storedIDs.length-1) {
          this.dispatch('updateNewMessagesCounters');
        }
      });
    },
    initTimers({commit}) {
      const refreshCallback = async () => {
        this.dispatch('updateNewMessagesCounters');
        await this.dispatch('updateMessages');
        updateDialogNewMessagesTimer = setTimeout(refreshCallback, 10000);
      };
      updateDialogNewMessagesTimer = setTimeout(refreshCallback, 10000);
    },

    async addDialogByUserID({commit}, userID) {
      const userData = await adl.getUser(userID);
      const dialogData = {
        key: `u${userID}`,
        id: userID,
        title: userData.name,
        content: [],
        selectedText: '',
        form: '',
        users: [],
        group: null,
        user: userData,
        newMessageCount: 0
      };
      commit('addDialog', dialogData);
      return dialogData;
    },
    async openDialogByUserID({commit}, userID) {
      const key = `u${userID}`;
      const existDialog = this.state.dialogs.find(item => item.key === key);
      if (existDialog) {
        this.dispatch('openDialog', existDialog);
      } else {
        const dialogData = await this.dispatch('addDialogByUserID', userID);
        this.dispatch('openDialog', dialogData);
      }
    }
  },
  modules: {}
});
